import type { AdminGame } from '@mcgames/contracts';
import { Badge } from '@mcgames/ui';
import { useTranslation } from 'react-i18next';
import styles from './Games.module.css';

/** Draft or published, the best NZB check state of the versions and, when set, the broken flag. */
export function GameStatusBadges({ game }: { game: AdminGame }) {
  const { t } = useTranslation('admin');
  const nzbStatus = game.nzbStatus ?? 'none';
  return (
    <div className={styles['chips']}>
      <Badge tone={game.published ? 'accent' : 'default'}>
        {t(game.published ? 'games.status.published' : 'games.status.draft')}
      </Badge>
      <Badge tone={nzbStatus === 'missing' || nzbStatus === 'error' ? 'danger' : 'default'}>
        {t(`games.nzbBadge.${nzbStatus}`)}
      </Badge>
      {game.broken && <Badge tone="danger">{t('games.status.broken')}</Badge>}
    </div>
  );
}
